var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade-top"}},[(_vm.text)?_c('div',{class:['message', _vm.classes]},[_c('button',{staticClass:"close",on:{"click":_vm.closeMessage}},[_vm._v("×")]),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }